import { useState, useCallback } from 'react';
import { TaskComponent as Task, TaskProps } from 'views/Aide/Scenario/Task';
import { PolicyComponent as Policy, PolicyValue } from 'views/Aide/Scenario/Policy';

export interface MarketingTaskProps
  extends Pick<TaskProps, 'editable' | 'activePolicyId' | 'activeRoundId' | 'value'> {}

function MarketingTask(props: MarketingTaskProps) {
  const { value: valueProp, ...others } = props;

  const { scenarioType, platform, region } = valueProp;

  const [page, setPage] = useState<'task' | 'policy'>('task');

  const [showTip, setShowTip] = useState(true);

  const [taskValue, setTaskValue] = useState(valueProp);

  const [policyValue, setPolicyValue] = useState<PolicyValue>();

  const onBack = useCallback(() => {
    setPage('task');
    setShowTip(false);
  }, []);

  if (page === 'policy' && policyValue) {
    return <Policy routeMode={false} value={policyValue} onBack={onBack} />;
  }

  return (
    <Task
      routeMode={false}
      value={taskValue}
      onChange={setTaskValue}
      onToPolicy={(partial) => {
        setPage('policy');
        setPolicyValue({
          scenarioType,
          platform,
          region,
          ...partial,
        });
      }}
      showActivePolicyTip={showTip}
      {...others}
    />
  );
}

export default MarketingTask;
